export enum JournalType {
  Bank = 'Bank',
  Open = 'Open',
  Close = 'Close',
  CashIn = 'CashIn',
}

export enum JournalBankEventType {
  CashCollection = 'Cash Collection',
  Bank = 'Bank',
  HandOver = 'Hand Over',
  MobileMoneyCollection = 'Mobile Money Collection',
  Expenses = 'Expenses',
  Purchases = 'Purchases',
  Other = 'Other',
}

export enum JournalCashInEventType {
  Topup = 'Topup',
}
